var formData = JSON.stringify({
  grant_type: "client_credentials",
  client_secret: "q1tnWxDWObB0KhWO4MZnUc8Abe6MkmUk53UAqMjK",
  client_id: "2",
});

export default function getAccessToken() {
  return fetch("https://consupedia.se/oauth/token", {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    body: formData,
  })
    .then((res) => res.json())
    .then((response) => JSON.stringify(response.access_token))
    .catch((error) => console.error("Error:", error));
}
